module.exports = __webpack_public_path__ + "static/desktop-footer-smh-773d45da4aa8e23f534503dc16a104ea.jpg";